import React, { useState, useEffect } from "react";
import DefaultAvatar from "./DefaultAvatar";

const ProfileImage = ({
  src,
  name = "U",
  size = 120,
  className = "",
  proxiedUrl = null,
  avatarProps = {},
  imgStyle = {},
  crossOrigin = "anonymous",
}) => {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [src]);

  const normalizedSrc = src && typeof src === "string" ? src.trim() : src;
  const hasValidSrc =
    normalizedSrc &&
    normalizedSrc !== "" &&
    normalizedSrc !== "undefined" &&
    normalizedSrc !== "null" &&
    typeof normalizedSrc === "string";

  const imageSrc =
    hasValidSrc && proxiedUrl
      ? proxiedUrl(normalizedSrc)
      : hasValidSrc
      ? normalizedSrc
      : null;

  const isS3Url =
    hasValidSrc &&
    typeof normalizedSrc === "string" &&
    normalizedSrc.includes("story-tent-testing.s3.ap-south-1.amazonaws.com");

  const shouldUseCrossOrigin = !isS3Url && crossOrigin;

  if (
    !hasValidSrc ||
    imageError ||
    !imageSrc ||
    imageSrc === "" ||
    imageSrc === "undefined" ||
    imageSrc === "null"
  ) {
    return (
      <DefaultAvatar
        name={name}
        size={size}
        className={className}
        {...avatarProps}
      />
    );
  }

  return (
    <img
      src={imageSrc}
      alt=""
      className={className}
      crossOrigin={shouldUseCrossOrigin ? crossOrigin : undefined}
      onError={() => setImageError(true)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        objectFit: "cover",
        ...imgStyle,
      }}
    />
  );
};

export default ProfileImage;
